import { OnboardingProps } from "../models";

/**
 * Merge late-arriving prefill (`incoming`) into the user's `current` form values
 * without clobbering anything the user has already entered. Any field that is set
 * (non-empty) in `current` wins; fields still empty in `current` are seeded from
 * `incoming`.
 *
 * This is what lets an async prefill source (prospector lookup, website crawl)
 * resolve after the user has started typing without resetting their input.
 */
export function mergeInitialOnboardingProps(incoming?: OnboardingProps, current?: OnboardingProps): OnboardingProps {
    const base: OnboardingProps = { ...(incoming ?? {}) };

    if (!current) {
        return base;
    }

    (Object.keys(current) as (keyof OnboardingProps)[]).forEach((key) => {
        const value = current[key];
        const isEmptyString = typeof value === "string" && value.trim().length === 0;
        if (value != null && !isEmptyString) {
            Object.assign(base, { [key]: value });
        }
    });

    return base;
}
